import * as signalR from "@microsoft/signalr";

import { getAccessToken } from 'utils/accessHelpers'
import { APP_BASE_URL } from 'utils/helperConfig'

const signalRConnection = new signalR.HubConnectionBuilder()
.withUrl(`${APP_BASE_URL}/hubs/notification`, { accessTokenFactory: () => getAccessToken() })
.withAutomaticReconnect()
.build()

export default signalRConnection;
